import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-660891a0")

_pushScopeId("data-v-660891a0")
const _hoisted_1 = { class: "table" }
const _hoisted_2 = {
  key: 0,
  class: "table__body table__body--empty scrollbar--invisible"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("i", { class: "icon-spinner animate-spin" }),
  /*#__PURE__*/_createTextVNode("Chargement...")
], -1)
const _hoisted_4 = {
  key: 1,
  ref: "timeslots",
  class: "table_body"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TheAvailableTimeslots = _resolveComponent("TheAvailableTimeslots")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.timeslotsLoading)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _hoisted_3
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_4, [
          (_ctx.isAdmin)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _createVNode(_component_TheAvailableTimeslots, { match: _ctx.emptyMatchDef }, null, 8, ["match"])
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_6, [
                _createVNode(_component_TheAvailableTimeslots, {
                  match: _ctx.emptyMatchDef,
                  booked: false,
                  available: false
                }, null, 8, ["match"])
              ]))
        ], 512))
  ]))
})